import React from 'react';
import { 
  FileText, 
  Flame, 
  HeartPulse, 
  Award, 
  ClipboardCheck, 
  Users, 
  Calendar, 
  MapPin, 
  Map 
} from 'lucide-react';

const services = [
  {
    title: "Alvará de Funcionamento",
    description: "Municipal",
    icon: <FileText className="text-brand-blue" size={32} />,
  },
  {
    title: "Alvará do Corpo de Bombeiros",
    description: "AVCB e CLCB",
    icon: <Flame className="text-brand-blue" size={32} />,
  },
  {
    title: "Alvará Sanitário",
    description: "Licença Sanitária Inicial e Renovação. Acompanhamento de processos e assessoria técnica.",
    icon: <HeartPulse className="text-brand-blue" size={32} />,
  },
  {
    title: "Certificação de Regularidade Técnica",
    description: "CRF, CRO, COREN, CREA, CAU, CREFITO e demais conselhos profissionais.",
    icon: <Award className="text-brand-blue" size={32} />,
  },
  {
    title: "Garantia da Qualidade",
    description: "Elaboração, revisão e aprovação de Manuais, POPs, Formulários e Registros.",
    icon: <ClipboardCheck className="text-brand-blue" size={32} />,
  },
  {
    title: "Fornecedores Parceiros",
    description: "Indicação de fornecedores devidamente qualificados.",
    icon: <Users className="text-brand-blue" size={32} />,
  },
  {
    title: "Gestão de Documentos",
    description: "Cadastro e acompanhamento de validade de documentos.",
    icon: <Calendar className="text-brand-blue" size={32} />,
  },
  {
    title: "CLI – Estado de SP",
    description: "Certificado de Licenciamento Integrado, específico para São Paulo.",
    icon: <MapPin className="text-brand-blue" size={32} />,
  },
  {
    title: "FCAM – Estado de SC",
    description: "Específico para o estado de Santa Catarina.",
    icon: <Map className="text-brand-blue" size={32} />,
  },
];

const Services: React.FC = () => {
  return (
    <section id="servicos" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-dark mb-4">Nossos Serviços</h2>
          <p className="text-gray-500 text-lg">Acompanhamento do início ao fim do processo. Conheça nossas soluções:</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="p-8 border border-gray-100 rounded-xl hover:shadow-lg transition-shadow bg-white flex flex-col items-start text-left">
              <div className="mb-6">{service.icon}</div>
              <h3 className="text-xl font-bold text-brand-dark mb-3">{service.title}</h3>
              {service.description && (
                <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
